export default function AllUsers() {
  return (
    <>
      <h1 className="text-lg text-center">All User page</h1>
    </>
  );
}
